import { Dialog, DialogType, IDialogProps } from "@fluentui/react";
import React, { FormEventHandler } from "react";
import { FormState } from "react-hook-form";

import { Form } from "../../forms/Form";
import { FormActions } from "../../forms/FormActions";
import { Stack } from "../../layouts/stack/Stack";

type FormDialogProps = Pick<IDialogProps, "hidden"> & {
    title: string;
    formState: FormState<unknown>;
    text?: string;
    showCloseButton?: boolean;
    isBlocking?: boolean;
    width?: number | string;
    contentHeight?: number;
    cancel?: {
        onClick(): void | Promise<void>;
        disabled?: boolean;
    };
    submit: {
        onClick: FormEventHandler<unknown>;
        disabled?: boolean;
    };
};

export const FormDialog: React.FC<FormDialogProps> = ({
    title,
    text,
    formState,
    hidden,
    showCloseButton,
    isBlocking,
    width,
    contentHeight,
    children,
    cancel,
    submit
}) => {
    const handleCancel = async () => {
        if (cancel) {
            await cancel.onClick();
        }
    };

    return (
        <Dialog
            dialogContentProps={{
                type: DialogType.normal,
                title: title,
                subText: text,
                styles: { subText: { marginBottom: 15 } },
                showCloseButton
            }}
            modalProps={{ isBlocking }}
            hidden={hidden || false}
            onDismiss={handleCancel}
            minWidth={width}
        >
            <Form onSubmit={submit.onClick}>
                {children && (
                    <Stack styles={{ root: { maxHeight: contentHeight, overflowY: "auto", overflowX: "auto" } }}>
                        {children}
                    </Stack>
                )}
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={handleCancel}
                    submitDisabled={submit.disabled}
                />
            </Form>
        </Dialog>
    );
};
